import React, { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import dayjs from 'dayjs';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ColumnChartByYear = ({dataInput}) => {
  
  // Chart data
  const data = {
    labels: dataInput.map((val) => val.month), // Use month labels (e.g., 'JAN', 'FEB', ...)
    datasets: [
      {
        label: 'Cost per month',
        data: dataInput.map((val) => !!val.executionsCount ? val.executionsCount : 0),
        backgroundColor: 'rgba(34, 202, 236, 0.5)', 
        borderColor: 'rgba(34, 202, 236, 1)',
        borderWidth: 1,
        borderRadius: 10, // Rounded corners
        barThickness: 30, // Adjust bar width,
      },
    ],
  };

  // Chart configuration
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Remove the legend
      },
      tooltip: {
        enabled: true, // Show tooltips on hover
      },
      title: {
        display: false
      },
    },
    layout: {
      padding: {
        top: 20, // Extra space to prevent text overlap
      },
    },
    scales: {
      x: {
        title: {
          display: false
        },
        grid: {
          display: false, // Remove grid lines
        },
      },
      y: {
        display: false, // Display Y-axis
      },
    },
  };

  // Add a plugin to display values on top of the bars
  const valuePlugin = {
    id: 'valuePlugin',
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index];
          ctx.fillStyle = '#000';
          ctx.font = '12px Arial';
          ctx.textAlign = 'center';
          ctx.fillText(value, bar.x, bar.y - 5); // Position above each bar
        });
      });
    },
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '100%' }}>
      {/* Dropdown for selecting year */}
      {/* <div style={{ width: '100%' }}>
        <label htmlFor="year">Select Year: </label>
        <select
          id="year"
          value={selectedYear}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
        >
          {Array.from({ length: 10 }, (_, i) => {
            const year = dayjs().year() - i; // Generate years (current year to 10 years back)
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>
      </div> */}

      {/* Chart */}
      <div style={{ height: '100%', width: '100%' }}>
        <Bar data={data} options={options} plugins={[valuePlugin]} />
      </div>
    </div>
  );
};

export default ColumnChartByYear;
